import Vue from "vue";
import Vuex from "vuex";

Vue.use(Vuex);

const store = new Vuex.Store({
  state: {
    token: "",
    phoneNumber: "",
    success: '', //是否登录
    login:'',//是否弹窗
    museumCode:window.SITE_CONFIG.museumCode,//
  },
  mutations: {
  }
});

export default store;



// WEBPACK FOOTER //
// ./src/store/index.js